module.exports = [
	{
		"name": "Customer Contract Forms",
		"papers": [
			{
				"title": "Subscription Agreement",
				"id": "auth0-subscription-agmnt",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "November, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-subscription-agmnt-rev-2.1.0-(11-17)-11-16-17-CLICK-THROUGH.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-subscription-agmnt-rev-2.1.0-(11-17)-11-16-17-CLICK-THROUGH.pdf"
					}
				]
			},
			{
				"title": "Professional Services Terms",
				"id": "auth0-professional-services",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Professional-Services.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Professional-Services.pdf"
					}
				]
			},
			{
				"title": "Modification Policy",
				"id": "auth0-modification-rights",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Modification-Rights.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Modification-Rights.pdf"
					}
				]
			},
			{
				"title": "Auth0 Acceptable Use Policy",
				"id": "auth0-acceptable-use-policy",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Acceptable-Use-Policy.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Acceptable-Use-Policy.pdf"
					}
				]
			},
			{
				"title": "Beta Service Terms",
				"id": "auth0-beta-service-terms",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "November, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-beta-service-terms-rev1.0.1-v1.0.1-11-29-17.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-beta-service-terms-rev1.0.1-v1.0.1-11-29-17.pdf"
					}
				]
			}
		]
	},
	{
		"name": "Support Program and Service Levels",
		"papers": [
			{
				"title": "Support Program",
				"id": "auth0-support-program",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "December, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/Auth0-Support-Program-v2.0.3-12-11-17-0.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/Auth0-Support-Program-v2.0.3-12-11-17-0.pdf"
					}
				]
			},
			{
				"title": "Service Level Agreement",
				"id": "auth0-sla",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "November, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-sla-rev2.0.5-(11-17)-11-28-17.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/files/auth0-sla-rev2.0.5-(11-17)-11-28-17.pdf"
					}
				]
			}
		]
	},
	{
		"name": "Policies and Sub-Processors",
		"papers": [
			{
				"title": "Sub-Processors and Subcontractors",
				"id": "auth0-sub-processors",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg",
				"date": "October, 2017",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Sub-processors.pdf"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/legal/files/Auth0-Sub-processors.pdf"
					}
				]
			}
		]
	},
	{
		"name": "Auth0 Mutual Non-Disclosure Agreement",
		"papers": [
			{
				"title": "Auth0 Mutual Non-Disclosure Agreement",
				"id": "mutual-non-disclosure-agreement",
				"icon": "https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg",
				"date": "February, 2018",
				"actions": [
					{
						"action": "download",
						"file": "https://cdn.auth0.com/website/auth0-legal/mutual-non-disclosure-agreement.docx"
					},
					{
						"action": "open",
						"file": "https://cdn.auth0.com/website/auth0-legal/mutual-non-disclosure-agreement.docx"
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/legal/data/legalPapers.json
// module id = 1413
// module chunks = 0